(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('.site-header');
    const toggle = document.querySelector('[data-menu-toggle]');

    function setOpen(open) {
      if (!header || !toggle) return;
      header.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute(
        'aria-label',
        open ? toggle.dataset.closeLabel || 'Close' : toggle.dataset.openLabel || 'Menu'
      );
    }

    if (header && toggle) {
      toggle.addEventListener('click', () => {
        setOpen(!header.classList.contains('is-open'));
      });

      header.querySelectorAll('.nav a').forEach((link) => {
        link.addEventListener('click', () => setOpen(false));
      });

      window.matchMedia('(max-width: 850px)').addEventListener('change', (event) => {
        if (!event.matches) setOpen(false);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SPEED = 90;

    function fillGroup(group, phrase, minWidth) {
      let buffer = phrase;
      group.textContent = buffer;
      let guard = 0;
      while (group.scrollWidth < minWidth && guard < 40) {
        buffer += phrase;
        group.textContent = buffer;
        guard += 1;
      }
    }

    function setup(root) {
      const track = root.querySelector('.marquee__track');
      const groups = root.querySelectorAll('.marquee__group');
      const phrase = (root.dataset.text || '').trim();
      if (!track || groups.length < 2 || !phrase) return;

      const text = phrase.endsWith(' ') ? phrase : phrase + ' ';
      fillGroup(groups[0], text, root.offsetWidth);
      groups[1].textContent = groups[0].textContent;

      const duration = Math.max(groups[0].scrollWidth / SPEED, 8);
      track.style.setProperty('--marquee-duration', duration + 's');
    }

    function init() {
      document.querySelectorAll('[data-marquee]').forEach(setup);
    }

    init();

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(init, 150);
    });

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-marquee]');
      if (root) setup(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["redirect"]) return;
  try {
    
  (function () {
    var link = document.querySelector('.vetrina-redirect a');
    if (link) window.location.replace(link.href);
  })();

  } catch(e) { console.error(e); }
})();
})();
